module.exports = __webpack_public_path__ + "img/timeline_miscevent-13.2d5c6a4c.jpg";